// Fills the product page's "Recently viewed" strip.
//
// RecentlyViewed stores product IDs only, so the products are re-fetched with a
// search for `id:X OR id:Y` through the Section Rendering API — the same trick
// assets/predictive-search.js uses for its own recently-viewed list. The section
// requested is the search template's results section, so the cards come back
// with the site's standard block configuration instead of a hand-rolled copy.

import { RecentlyViewed } from '@theme/recently-viewed-products';

function currentProductId() {
  return document.querySelector('[data-product-id]')?.dataset.productId || '';
}

/** Search returns relevance order; restore the order they were actually viewed in. */
function sortToViewedOrder(grid, ids) {
  const rank = new Map(ids.map((id, index) => [String(id), index]));
  const items = [...grid.children];

  items
    .map((item) => ({
      item,
      rank: rank.get(item.querySelector('[data-product-id]')?.dataset.productId ?? '') ?? Infinity,
    }))
    .sort((a, b) => a.rank - b.rank)
    .forEach(({ item }) => grid.appendChild(item));
}

async function fillStrip(container) {
  // The product being viewed is already on screen — showing it back is noise.
  const current = currentProductId();
  const ids = RecentlyViewed.getProducts().filter((id) => String(id) !== String(current));
  if (ids.length === 0) return;

  const { searchUrl, searchSection } = container.dataset;
  if (!searchUrl || !searchSection) return;

  const url = new URL(searchUrl, location.origin);
  url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
  url.searchParams.set('resources[type]', 'product');
  url.searchParams.set('section_id', searchSection);

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const grid = doc.querySelector('.product-grid');
    if (!grid || grid.children.length === 0) return;

    sortToViewedOrder(grid, ids);
    container.querySelector('[data-recently-viewed-body]')?.replaceChildren(grid);
    container.hidden = false;
  } catch (error) {
    // A missing strip is not worth an error state — leave it hidden.
    console.warn('Recently viewed: failed to load', error);
  }
}

document.querySelectorAll('[data-recently-viewed]').forEach(fillStrip);
